export interface OutcomePublic {
  id: string;
  title: string;
  headerLabel: string;
  priceImpact: number;
  DiscountValue: number;
  message: string;
  callToAction: string;
  url: string;
  recommendedLabel: string;
  relatedLabel: string;
  recommendedProductIds: string[];
  relatedProductIds: string[];
  type: EOutcomeType;
  questionnaireId: string;
  callToActions: CallToAction[];
  schedulingEnabled?: boolean;
  schedulingTitle?: string | null;
  paymentEnabled?: boolean;
  paymentTitle?: string | null;
  paymentSubTitle?: string | null;
  PTID: string | null;
  completeQuestionnaireId?: string;
}

export interface CallToAction {
  id: string;
  title: string;
  value: string;
  phoneCode: string;
  type: string;
  isActive: boolean;
  outcomeId: string;
  isSecondary: boolean;
}

type OutcomeType = 'Product' | 'ThankYou';

export enum EOutcomeType {
  ThankYou = 'ThankYou',
  Product = 'Product',
  Redirect = 'Redirect'
}

export enum TimeType {
  Question = 'Question',
  Morning = 'Morning',
  Afternoon = 'Afternoon',
  Evening = 'Evening'
}

export enum EPaymentState {
  Scheduling = 'Scheduling',
  Payment = 'Payment',
  Success = 'Success'
}
